import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import Modal from "components/ui/Modal/Modal";

interface RouterPromptProps {
  when: boolean;
  onOK?: () => boolean;
  onCancel?: () => boolean;
  title: string;
  okText: string;
  cancelText: string;
}

const RouterPrompt: React.FC<RouterPromptProps> = ({
  when,
  onOK,
  onCancel,
  title,
  okText,
  cancelText,
}) => {
  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (when) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
        return "true";
      });
    } else {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      history.block(() => {});
    }

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      history.block(() => {});
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());
      if (canRoute) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        history.block(() => {});
        history.push(currentPath);
      }
    }
  }, [currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel());
      if (canRoute) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        history.block(() => {});
        history.push(currentPath);
      }
    }
    setShowPrompt(false);
  }, [currentPath, history, onCancel]);

  return showPrompt ? (
    <Modal
      title={title}
      isOpen={showPrompt}
      onOk={handleOK}
      okText={okText}
      onCancel={handleCancel}
      cancelText={cancelText}
      type="alert"
      alertType="warning"
      showCancelButton
      size="medium"
    />
  ) : null;
};

export default RouterPrompt;
